module.exports = __webpack_public_path__ + "assets/wedoreparation.16d4f989f96467a42f958701316c0c64.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/wedoreparation.png
 ** module id = 380
 ** module chunks = 0
 **/